export const accountId = '{accountId}';
export const partyId = '{partyId}';
export const userId = '{userId}';
export const shopUid = 'shopUid';
export const shopUidParam = '{shopUidParam}';
export const itemListUid = 'itemListUid';
export const shopPk = '{shopPk}';
export const itemId = '{itemId}';
export const cartId = '{cartId}';
export const shoplistUid = '{shoplistUid}';
export const entryNumber = '{entryNumber}';
export const entryId = '{entryId}';
export const entryPk = '{entryPk}';
export const voucherId = '{voucherId}';
export const addressType = '{addressType}';
export const postalCode = '{postalCode}';
export const parentCartId = '{parentCartId}';
export const productCode = '{productCode}';
export const aliasCode = '{aliasCode}';
export const orderCode = '{orderCode}';
export const orderId = '{orderId}';
export const referralAbo = 'referralAbo';
export const file = 'file';
export const formContentType = 'multipart/form-data';
export const emptyContentType = 'emptyContentType';

export const getShopInfoAPI = 'getShopInfoAPI';
export const getShopSponsorAPI = 'getShopSponsorAPI';
export const updateShopInfoAPI = 'updateShopInfoAPI';
export const getShopListAPI = 'getShopListAPI';
export const getColorListAPI = 'getColorListAPI';
export const cartDetailsByCartIdAPI = 'cartDetailsByCartIdAPI';
export const getShoplistDetailAPI = 'getShoplistDetailAPI';
export const getShoplistPromotionAPI = 'getShoplistPromotionAPI';
export const updateEntryInCartApi = 'updateEntryInCartAPI';
export const productSearchAPI = 'productSearchAPI';
export const addProductToShopAPI = 'addProductToShopAPI';
export const createNewShopListAPI = 'createNewShopListAPI';
export const validateShopNameAPI = 'validateShopNameAPI';
export const addBundleProductAPI = 'addBundleProductAPI';
export const getShoplistDetailByIdAPI = 'getShoplistDetailByIdAPI';
export const removeProductFromListAPI = 'removeProductFromListAPI';
export const updateProductInListAPI = 'updateProductInListAPI';
export const updateShoplistDetailAPI = 'updateShoplistDetailAPI';
export const applyCouponApi = 'applyCouponAPI';
export const removeCouponApi = 'removeCouponAPI';
export const getTinyUrlAPI = 'getTinyUrlAPI';
export const createCartApi = 'createCartAPI';
export const addProductToCartApi = 'addProductToCartAPI';
export const getProductDetailsAPI = 'getProductDetailsAPI';
export const getProductDetailsFromAliasCodeAPI = 'getProductDetailsFromAliasCodeAPI';
export const decodeTinyUrlAPI = 'decodeTinyUrlAPI';
export const getOrderDetailsAPI = 'getOrderDetailsAPI';
export const getGroupOrderDetailsAPI = 'getGroupOrderDetailsAPI';

export const getABOImageAPI = 'getABOImageAPI';
export const retrieveImageByUrlAPI = 'retrieveImageByUrlAPI';
export const validateCaptchaAPI = 'validateCaptchaAPI';
export const getOccAuthTokenAPI = 'getOccAuthTokenAPI';
export const getProvinceListAPI = 'getProvinceListAPI';
export const getDistrictsAPI = 'getDistrictsAPI';
export const mdmsCountryListAPI = 'mdmsCountryListAPI';
export const getCountryListAPI = 'getCountryListAPI';
export const validateCidAPI = 'validateCidAPI';
export const validateContactsAPI = 'validateContactsAPI';
export const validateSponsorABOAPI = 'validateSponsorABOAPI';
export const retrieveSponsorByPostalCodeAPI = 'retrieveSponsorByPostalCodeAPI';
export const createRegistrationCartAPI = 'createRegistrationCartAPI';
export const updateCustomerAPI = 'updateCustomerAPI';
export const updateRegistrationCartAPI = 'updateRegistrationCartAPI';
export const saveRegistrationDataAPI = 'saveRegistrationDataAPI';
export const validateCartAPI = 'validateCartAPI';
export const freezeCartAPI = 'freezeCartAPI';
export const combineCartsAPI = 'combineCartsAPI';
export const getExtendedCartByIdAPI = 'getExtendedCartByIdAPI';
export const updateFoaFlagInCartApi = 'updateFoaFlagInCartAPI';
export const getCouponsApi = 'getCouponsAPI';
export const validatePidAPI = 'validatePidAPI';
export const assignRegistrationCartAPI = 'assignRegistrationCartAPI';
export const getAccountAddressBookAPI = 'getAccountAddressBookAPI';
export const addNewAddressAPI = 'addNewAddressAPI';
export const updateAddressInCartAPI = 'updateAddressInCartAPI';
export const assignCartToCustomerAPI = 'assignCartToCustomerAPI';
export const uploadDocumentAPI = 'uploadDocumentAPI';
export const generateOtpAPI = 'generateOtpAPI';
export const validateOtpAPI = 'validateOtpAPI';
export const validateOtpForDowngradeAPI = 'validateOtpForDowngradeAPI';
export const validatePhoneNumberAPI = 'validatePhoneNumberAPI';

export const shopFoaProductsAPI = 'shopFoaProductsAPI';
export const productRegionAvailabilityAPI = 'productRegionAvailabilityAPI';
export const removeMultipleEntryFromCartApi = 'removeMultipleEntryFromCartAPI';
export const authorizationApi = 'authorizationAPI';
export const validatePaymentRetryAPI = 'validatePaymentRetryAPI';
export const deleteShoplistAPI = 'deleteShoplistAPI';
export const getMdmsFullAccountDetailAPI = 'getMdmsFullAccountDetailAPI';
export const upgradeAccountAPI = 'upgradeAccountAPI';
export const changePartyRoleAPI = 'changePartyRoleAPI';
export const getContractInfoAPI = 'getContractInfoAPI';
export const verifyIdCardOnCredenAPI = 'verifyIdCardOnCredenAPI';
export const downgradeAccountAPI = 'downgradeAccountAPI';
export const checkAvailabilityOfShopUidAPI = 'checkAvailabilityOfShopUidAPI';
export const fetchShopProfileImageAPI = 'fetchShopProfileImageAPI';
export const uploadShopProfileImageAPI = 'uploadShopProfileImageAPI';
export const getMobHeaderClassAPI = 'getMobHeaderClassAPI';
export const updateAuxillaryProductsAPI = 'updateAuxillaryProductsAPI';

